import Service from "../../services"

const MedGroup = {
  namespaced: true,
  state: {
    medGroups: [],
    medSubGroups: [],
    medGroup: {}
  },
  mutations: {
    SET_MED_GROUPS: (state, medGroups) => {
      state.medGroups = medGroups
    },
    SET_ALL_MED_GROUPS: (state, medGroups) => {
      state.medGroups = medGroups
    },
    SET_MED_SUB_GROUPS: (state, medSubGroups) => {
      state.medSubGroups = medSubGroups
    },
    SET_MED_GROUP: (state, medGroup) => {
      state.medGroup = medGroup
    },
    CLEAR_MED_SUB_GROUP: (state) => {
      state.medSubGroups = [];
    }
  },
  actions: {
    async getMedGroups ({ commit }) {
      const data = await Service.MedGroup.getSearch({
        group_level: 1,
      })
      commit('SET_MED_GROUPS', data)
    },
    async getAllMedGroups ({ commit }) {
      const data = await Service.MedGroup.getSearch({
        group_level: 1,
        getall: 1,
      })
      commit('SET_ALL_MED_GROUPS', data)
    },
    async getMedSubGroups ({ commit }, medGroupId) {
      // const data = await Service.MedGroup.getSearch({
      //   group_main: medGroupId,
      //   group_level: 2,
      // })
      const data = await Service.MedGroup.getSubGroup(medGroupId)
      commit('SET_MED_SUB_GROUPS', data)
    },
    async getMedGroup ({ commit }, id) {
      const data = await Service.MedGroup.getById(id)
      commit('SET_MED_GROUP', data)
    },
    clearMedSubGroup ({ commit }) {
      commit('CLEAR_MED_SUB_GROUP')
    }
  }
}

export default MedGroup
